/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateScanRequest {
    getFixupPrototypeFunction() { return TemplateScanRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateScanRequest>): TemplateScanRequest {
        let obj = Object.assign(new TemplateScanRequest(), model);
        TemplateScanRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateScanRequest>): TemplateScanRequest {
        if (!model) return null;
        return TemplateScanRequest.newInstance(<TemplateScanRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateScanRequest) {
        if (!obj) return;

        models.TemplateScanRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateScanRequest): boolean {
        Object.setPrototypeOf(obj, TemplateScanRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.service_account) {
            models.TemplateServiceAccount.fixupPrototype(this.service_account);
        }
        if (this.params) {
            for (let val of this.params) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
    }

    /**
     * Parameter values to substitute into the template content before scanning
     */
    params: Array<models.NamedParameter>;

    /**
     * Service account context needed for account-aware checks. Optional.
     */
    service_account: models.TemplateServiceAccount;

}
